import { render } from "./Credit_Notes.vue?vue&type=template&id=16a93ff2&scoped=true"
import script from "./Credit_Notes.vue?vue&type=script&lang=js"
export * from "./Credit_Notes.vue?vue&type=script&lang=js"

import "./Credit_Notes.vue?vue&type=style&index=0&id=16a93ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a93ff2"]])

export default __exports__